import { Checkbox } from 'antd';
import { useController } from 'react-hook-form';
import { InfoIcon, TextInputField } from './fields';
import PaymentGroupField from './PaymentGroupField';
import { FIELD_LABELS, FIELD_PLACEHOLDERS, paymentMethodPopover, PHONE_MAX_DIGITS, STEP_HEADINGS } from './constants';
import type { ClientFormValues } from '../../../../types/ClientManagementTypes';
import styles from './ClientFormModal.module.scss';

// Sits beside the payment method field rather than owning a row of its own.
const MarkAsPaidCheckbox = () => {
  const { field } = useController<ClientFormValues>({ name: 'markAsPaid' });
  return (
    <div className={styles.paymentPaidRow}>
      <Checkbox className="custom-checkbox" checked={field.value as boolean} onChange={(event) => field.onChange(event.target.checked)}>
        <span className={styles.optionLabel}>{FIELD_LABELS.MARK_AS_PAID}</span>
      </Checkbox>
    </div>
  );
};

const PaymentStep = () => (
  <section className={styles.step}>
    <h3 className={styles.stepHeading}>{STEP_HEADINGS.PAYMENT_INFORMATION}</h3>
    <PaymentGroupField />
    <TextInputField name="contactName" label={FIELD_LABELS.CONTACT_NAME} placeholder={FIELD_PLACEHOLDERS.CONTACT_NAME} />
    <TextInputField name="contactEmail" label={FIELD_LABELS.CONTACT_EMAIL} placeholder={FIELD_PLACEHOLDERS.CONTACT_EMAIL} />
    <TextInputField
      name="contactPhone"
      label={FIELD_LABELS.CONTACT_PHONE}
      placeholder={FIELD_PLACEHOLDERS.CONTACT_PHONE}
      maxLength={PHONE_MAX_DIGITS}
      digitsOnly
    />
    <div className={styles.paymentMethodRow}>
      <TextInputField
        name="paymentMethod"
        label={FIELD_LABELS.PAYMENT_METHOD}
        placeholder={FIELD_PLACEHOLDERS.PAYMENT_METHOD}
        info={<InfoIcon content={paymentMethodPopover} />}
        className={styles.paymentMethodInput}
      />
      <MarkAsPaidCheckbox />
    </div>
  </section>
);

export default PaymentStep;
